module.exports = __webpack_public_path__ + "static/media/radial_checkin.c0f9c397.png";